import React, { Component } from "react";
import Header from "./Header";
import Footer from "./Footer";
import HeaderIntro from "./HeaderIntro";
import NewsLetter from "./NewsLetter";
export class GstReturnFiling extends Component {
  render() {
    return (
      <div>
        <Header />
        <HeaderIntro />

        <section id="about" style={{ backgroundColor: "#f3f9fd" }}>
          <div class="container" data-aos="fade-up">
            <header class="section-header">
              <h3>GST Return Filing Online in India</h3>
              {/* <p>Services Start as low as ₹49</p> */}

              {/* <h3></h3> */}
              <p>
              CTA : Get your GST Return Filing done every month and every year at
                the lowest price in India.
              </p>
            </header>
          </div>
        </section>

        <section id="why-us" style={{ backgroundColor: "#f3f9fd" }}>
          <div class="container" data-aos="fade-up">
            <header class="section-header">
              <h3>How Does GST Return Filing Work?</h3>
              <p>
                Failure to file nil return of GST could attract a penalty of INR
                20 per day.
              </p>
            </header>

            <div class="row row-eq-height justify-content-center">
              <div class="col-lg-4 mb-4">
                <div class="card" data-aos="zoom-in" data-aos-delay="100">
                  {/* <i class="fa fa-diamond"></i> */}
                  <div class="card-body">
                    <h5 class="card-title">Step 1:</h5>
                    <p class="card-text">
                      Information Collection: Our team will set up a seamless
                      process for data collection
                    </p>
                    {/* <a href="#" class="readmore">
                      Read more{" "}
                    </a> */}
                  </div>
                </div>
              </div>

              <div class="col-lg-4 mb-4">
                <div class="card" data-aos="zoom-in" data-aos-delay="200">
                  {/* <i class="fa fa-language"></i> */}
                  <div class="card-body">
                    <h5 class="card-title">Step 2:</h5>
                    <p class="card-text">
                      Return Preparation: Your return will be prepared as
                      required
                    </p>
                    {/* <a href="#" class="readmore">
                      Read more{" "}
                    </a> */}
                  </div>
                </div>
              </div>

              <div class="col-lg-4 mb-4">
                <div class="card" data-aos="zoom-in" data-aos-delay="300">
                  {/* <i class="fa fa-object-group"></i> */}
                  <div class="card-body">
                    <h5 class="card-title">Step 3:</h5>
                    <p class="card-text">
                      Return Filing: Before you know it, your return will be
                      ready for filing{" "}
                    </p>
                    {/* <a href="#" class="readmore">
                      Read more{" "}
                    </a> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <NewsLetter/>
        <Footer />
      </div>
    );
  }
}

export default GstReturnFiling;
